import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import theme from './theme';
import ErrorBoundary from './components/ErrorBoundary';
// v2.2.31：把 .wt-* 宽表 CSS 注入全局。原因：WideTableHtml 用 sx 写 scoped 样式时，
// 只有它自己的根 Box 能吃到 .wt-table 规则；而表格是被 wrapTables() 塞进 .wt-viewport 的
// 动态 DOM，emotion 的 scoped 选择器在部分场景匹配不到。改全局后一劳永逸。
import { WideTableGlobalStyles } from './components/WideTableHtml';
import './index.css';

// BrowserRouter 深链垫片（2026-10-08 实测根因修复）：活动二维码/历史链接是 #/path?query 形态，
// 而 BrowserRouter 只认真实路径，hash 内的 act/code/wx_login_error 等参数路由层完全不可见，
// 未登录访客会被 <Navigate to="/login"> 带到路径 /login、深链参数全部丢失。
// 在路由渲染前把 #/xxx?a=b 归位为 /xxx?a=b，一次替换即可，同时救活所有历史 hash 深链。
(function normalizeLegacyHashDeepLink() {
  const h = window.location.hash || '';
  if (h.indexOf('#/') !== 0) return;
  const rest = h.slice(1); // '#/my-activities?act=x' -> '/my-activities?act=x'
  window.history.replaceState(null, '', rest);
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <WideTableGlobalStyles />
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
